import React from "react";
import api from './../../../services/api';
//import axios from 'axios';
import "./../../../pages/Representante_Instituição/Tela_RI_Solicitar_Consulta";
//import { AiOutlineSearch } from "react-icons/ai";
//import { IoIosArrowDown } from "react-icons/io";
//import { Collapse } from "react-collapse";
//import Checkbox from '@material-ui/core/Checkbox';
//import FormGroup from '@material-ui/core/FormGroup';
//import FormControlLabel from '@material-ui/core/FormControlLabel';
import { user_token } from "../../../services/Auth";

var token = localStorage.getItem(user_token);
var _id = localStorage.getItem("id_agent");
//var usuario_id = localStorage.setItem("user_id");


export default class Form_RI_SolicitarConsulta extends React.Component {

    componentDidMount() {
        const { id } = this.props.user_id;
        //console.log("DEBUG ESSA AQUI É A ID:" + id);
        console.log(localStorage.getItem("id_agent"));
        localStorage.setItem('user_id', id);
        
    }


    constructor() {
        super();
        this.state = {

            agent_id: "",
            user_id: "",
            professional_id: "",
            appointment_date: "",
            appointment_period: "",
            //matutino: false,
            //vespertino: false,
            //noturno: false,
            appointment_purpose: "",
            appointment_type: "",
            date: "",
            medical_appointment_type: "",
            notes: "",
            possible_date: [],
            status: "Pendente",
            prescription: "",


        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleSelect(event) {
        this.setState({ instituction_id: event.target.value });
    }

    _collapseID(open) {
        if (open === "Outra") {
            return true;
        }
        else {
            return false;
        }
    };

    _collapseType(open) {
        if (open === "Outra") {
            return true;
        }
        else {
            return false;
        }
    };

    _collapseMedica(open) {
        if (open === "Consulta Medica") {
            return true;
        }
        else {
            return false;
        }
    };

    _handleChangeCheckbox = (event) => {
        if (event.target.name === 'matutino') {
            this.setState({
                [event.target.name]: !this.state.matutino
            })
        }
        if (event.target.name === 'vespertino') {
            this.setState({
                [event.target.name]: !this.state.vespertino
            })
        }
        if (event.target.name === 'noturno') {
            this.setState({
                [event.target.name]: !this.state.noturno
            })
        }
        this.generatePeriod(this.state.matutino, this.state.vespertino, this.state.noturno)
    };


    generatePeriod(matutino, vespertino, noturno) {
        this.setState({
            appointment_period: matutino + "_" + vespertino + "_" + noturno
        })
        return
    }
    _handleSubmit = evt => {
        evt.preventDefault();
        const exam = {

            agent_id: localStorage.getItem("id_agent"),
            user_id: localStorage.getItem("user_id"),
            professional_id: this.state.professional_id,
            appointment_date: this.state.appointment_date,
            appointment_period: this.state.appointment_period,
            appointment_purpose: this.state.appointment_purpose,
            appointment_type: this.state.appointment_type,
            date: this.state.date,
            medical_appointment_type: this.state.medical_appointment_type,
            notes: this.state.notes,
            possible_date: this.state.possible_date,
            status: this.state.status,
            prescription: this.state.prescription,

        }

        console.log(exam)
        api.post(`/exam`, exam, { headers: { 'x-access-token': token } })
            .then(res => {
                console.log(res);
                console.log(res.data);
                alert("Consulta Solicitada com sucesso!");
                //this.props.history.push("/RI_Painel");
            })

    }

    render() {
        return (
            <>
                <div id="collapsed-Solicitar">
                    <form onSubmit={this._handleSubmit} id="RI-Solicitar-Form">
                        <h1 id="tittle-forms-cme">Formulário de Consulta</h1>
                        <br></br>

                        <p id="RI-Title-Solicitar">Qual o motivo da consulta?</p>
                        <input name="appointment_purpose" onChange={this.handleChange} placeholder="Insira o motivo da consulta:" type="text" id="RI-Solicitar-Forms" />

                        <p id="RI-Title-Solicitar">Qual é o tipo de consulta desejada?</p>
                        <div onChange={event => {
                            this.setState({
                                appointment_type: event.target.value,
                            })
                        }}>
                            <label id="RI-Solicitar-Later">
                                <input value="Consulta médica" name="appointment_type" type="radio" id="RI-Login" />Consulta médica 
                                    <span id="RI-Solicitar-Span"></span>
                            </label>
                            <label id="RI-Solicitar-Later">
                                <input value="Consulta de psicologia" name="appointment_type" type="radio" id="RI-Login" />Consulta de psicologia
                                    <span id="RI-Solicitar-Span"></span>
                            </label>
                            <label id="RI-Solicitar-Later">
                                <input value="Consulta de fisioterapia" name="appointment_type" type="radio" id="RI-Login" />Consulta de fisioterapia
                                    <span id="RI-Solicitar-Span"></span>
                            </label>

                            <label id="RI-Solicitar-Later">
                                <input value="Consulta de odontologia" name="appointment_type" type="radio" id="RI-Login" />Consulta de odontologia
                                    <span id="RI-Solicitar-Span"></span>
                            </label>

                            <label id="RI-Solicitar-Later">
                                <input value="Consulta de nutrição" name="appointment_type" type="radio" id="RI-Login" />Consulta de nutrição
                                    <span id="RI-Solicitar-Span"></span>
                            </label>

                            <label id="RI-Solicitar-Later">
                                <input value="Consulta de enfermagem" name="appointment_type" type="radio" id="RI-Login" />Consulta de enfermagem
                                    <span id="RI-Solicitar-Span"></span>
                            </label>

                            <label id="RI-Solicitar-Later">
                                <input value="Outra" name="appointment_type" type="radio" id="RI-Login" />Outra
                                    <span id="RI-Solicitar-Span"></span>
                            </label>
                        </div>

                        <p id="RI-Title-Solicitar">Especialidade Médica</p>
                        <input name="medical_appointment_type" onChange={this.handleChange} placeholder="Caso selecionado Consulta médica" type="text" id="RI-Solicitar-Forms" />

                        <p id="RI-Title-Solicitar">Período disponível para consulta</p>
                        <div onChange={event => {
                            this.setState({
                                appointment_period: event.target.value,
                            })
                        }}>
                            <label id="RI-Solicitar-Later">
                                <input value="Matutino" name="appointment_period" type="radio" id="RI-Login" />Matutino
                                    <span id="RI-Solicitar-Span"></span>
                            </label>

                            <label id="RI-Solicitar-Later">
                                <input value="Vespertino" name="appointment_period" type="radio" id="RI-Login" />Vespertino
                                    <span id="RI-Solicitar-Span"></span>
                            </label>

                            <label id="RI-Solicitar-Later">
                                <input value="Noturno" name="appointment_period" type="radio" id="RI-Login" />Noturno
                                    <span id="RI-Solicitar-Span"></span>
                            </label>
                        </div>

                        <p id="RI-Title-Solicitar">Notas</p>
                        <input name="notes" onChange={this.handleChange} placeholder="Insira: " type="text" id="RI-Solicitar-Forms" />

                        <div style={{ display: 'flex', justifyContent: "center" }}>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <button onClick={() => this._handleSubmit} id="submit-RI-Solicitar">Enviar</button>
                            </div>
                        </div>

                    </form>
                </div>
            </>
        );
    };
}


/* ORIGINAL DO ANTONIO

<p id="RI-Title-Solicitar">Nome completo do Representante de Instituição</p>
                        <input name="agent_name" onChange={this.handleChange} placeholder="Nome completo" type="text" id="RI-Solicitar-Forms" />
                        
                        <p id="RI-Title-Solicitar" >Qual é a sua instituição?</p>
                        <select value={this.state.instituction_id} onChange={this.handleSelect} id="RI-Solicitar-Forms">
                            <option>Selecionar</option>
                            <option value='UIPSS'>UIPSS</option>
                            <option value='UNAI'>UNAI</option>
                            <option value='UNAM'>UNAM</option>
                            <option value='UNAF'>UNAF</option>
                            <option value='Outra'>Outra</option>
                        </select>
                        
                        <Collapse isOpened={this._collapseID(this.state.instituction_id)}>
                            <input name="instituction_id" onChange={this.handleChange} placeholder="Qual é a sua instituição?" type="text" id="RI-Solicitar-Forms" />
                        </Collapse>
                        <p id="RI-Title-Solicitar">Qual é o tipo de consulta desejada?</p>
                        <div onChange={event => {
                            this.setState({
                                appointment_type: event.target.value,
                            })
                        }}>
                            <label id="RI-Solicitar-Later">
                                <input value="Consulta Medica" name="appointment_type" type="radio" id="RI-Login" />Consulta médica
                                    <span id="RI-Solicitar-Span"></span>
                            </label>
                            <label id="RI-Solicitar-Later">
                                <input value="Consulta psicologica" name="appointment_type" type="radio" id="RI-Login" />Consulta psicológica
                                    <span id="RI-Solicitar-Span"></span>
                            </label>
                            <label id="RI-Solicitar-Later">
                                <input value="Consulta fisioterapeutica" name="appointment_type" type="radio" id="RI-Login" />Consulta fisioterapêutica
                                    <span id="RI-Solicitar-Span"></span>
                            </label>
                            <label id="RI-Solicitar-Later">
                                <input value="Outra" name="appointment_type" type="radio" id="RI-Login" />Outra
                                    <span id="RI-Solicitar-Span"></span>
                            </label>
                        </div>

                        <Collapse isOpened={this._collapseType(this.state.appointment_type)}>
                            <p id="RI-Title-Solicitar">Qual é o tipo da consulta desejada?</p>
                            <input name="appointment_type" onChange={this.handleChange} placeholder="Tipo de consulta" type="text" id="RI-Solicitar-Forms" />
                        </Collapse>

                        <Collapse isOpened={this._collapseMedica(this.state.appointment_type)}>
                            <p id="RI-Title-Solicitar">Qual é a especialidade da consulta?</p>
                            <input name="medical_appointment_type" onChange={this.handleChange} placeholder="Espacialidade" type="text" id="RI-Solicitar-Forms" />
                        </Collapse>

                        <p id="RI-Title-Solicitar">Nome do responsável pela requisição da consulta</p>
                        <input name="agent_name" onChange={this.handleChange} placeholder="Nome do responsável" type="text" id="RI-Solicitar-Forms" />
                        
                        <p id="RI-Title-Solicitar">Telefone do responsável</p>
                        <input name="agent_phone" onChange={this.handleChange} placeholder="Telefone do responsável" type="text" id="RI-Solicitar-Forms" />
                        
                        <p id="RI-Title-Solicitar">Qual é o objetivo da consulta?</p>
                        <input name="appointment_purpose" onChange={this.handleChange} placeholder="Objetivo da consulta" type="text" id="RI-Solicitar-Forms" />
                        
                        <p id="RI-Title-Solicitar">Período disponível para consulta</p>
                        <div style={{ display: "flex", flexDirection: "column" }}>

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.matutino}
                                        name="matutino"
                                        onChange={this._handleChangeCheckbox}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                }
                                label="Matutino"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.vespertino}
                                        name="vespertino"
                                        onChange={this._handleChangeCheckbox}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                }
                                label="Vespertino"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.noturno}
                                        name="noturno"
                                        onChange={this._handleChangeCheckbox}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                }
                                label="Noturno"
                            />
                        </div>
                        <p id="RI-Title-Solicitar">Qual é a idade do paciente?</p>
                        <input name="user_birth" onChange={this.handleChange} placeholder="Idade do paciente" type="text" id="RI-Solicitar-Forms" />
                        <p id="RI-Title-Solicitar">Qual é o nome do paciente?</p>
                        <input name="user_name" onChange={this.handleChange} placeholder="Nome do paciente" type="text" id="RI-Solicitar-Forms" />
                        <p id="RI-Title-Solicitar">Qual é o CPF do paciente?</p>
                        <input name="user_cpf" onChange={this.handleChange} placeholder="CPF" type="text" id="RI-Solicitar-Forms" />
                        <div style={{ display: 'flex', justifyContent: "center" }}>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <button onClick={() => this._handleSubmit} id="submit-RI-Solicitar">Enviar</button>
                            </div>
                        </div>

 * Set de estado original antes do alert
 this.setState({
                    appointment_type: "",
                    medical_appointment_type: "",
                    appointment_purpose: "",
                    appointment_period: "",
                    professional_name: "",
                    user_name: "",
                    user_birth: "",
                    user_cpf: "",
                    agent_phone: "",
                    agent_name: "",
                    instituction_id: "",
                })


* Input dos periodos

<p id="RI-Title-Solicitar">Período disponível para consulta</p>
                        <div style={{ display: "flex", flexDirection: "column" }}>

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.matutino}
                                        name="matutino"
                                        onChange={this._handleChangeCheckbox}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                }
                                label="Matutino"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.vespertino}
                                        name="vespertino"
                                        onChange={this._handleChangeCheckbox}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                }
                                label="Vespertino"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.noturno}
                                        name="noturno"
                                        onChange={this._handleChangeCheckbox}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                }
                                label="Noturno"
                            />
                        </div>


*/